/*
 * @Author: wangbaihe
 * @Date: 2023-07-21 11:41:58
 * @LastEditors: wangbaihe
 * @LastEditTime: 2024-06-27 16:53:20
 * @FilePath: \common-mediax\src\apis\MediaCloudArticleEdit\Permission.js
 * @Description: MediaCloudArticleEditPermission
 */
import { createAPI } from '../../common'

export default {
  /* 原来部门库是单独写的有很多bug 现在和稿源库和审稿库统一 */
  /* postPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0qfsnjttjpo', 'post', config),
    getPermissionAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0qfsnjttjpo0bmm', 'get', config) */
  postPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'post',
      config
    ),
  getPermissionAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'get',
      config
    ),
  // 畅想全媒体稿源库文件夹获取接口
  getRemoteRootTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0bsujdmf0sppu0tfoe0usff', 'get', config),
  // 畅想全媒体部门库文件夹获取接口
  getRemoteEditTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0bsujdmf0feju0tfoe0usff', 'get', config),
  // 畅想全媒体部门库文件夹所属用户获取接口
  getRemoteEditUsers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0vtfsgpmefs0vtfst', 'get', config),
  // 查看权限 待办
  getAssignStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bttjho0tubuvt', 'get', config),
  // 查看权限消息
  getDetailStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0efubjm0tubuvt', 'get', config)
}
